import { Union } from "../.fable/fable-library.3.1.4/Types.js";
import { Query$reflection, Command$reflection, Result$reflection } from "../../Shared/Api.fs.js";
import { unit_type, union_type, class_type } from "../.fable/fable-library.3.1.4/Reflection.js";
import { fableModule } from "../Global.fs.js";
import { Fetch_post_3817AB3A } from "../.fable/Dnn.Fable.Fetch.2.0.0/fetch.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../.fable/Fable.Promise.3.1.3/Promise.fs.js";
import { promise } from "../.fable/Fable.Promise.3.1.3/PromiseImpl.fs.js";
import { Cmd_OfPromise_either } from "../.fable/Fable.Elmish.3.1.0/cmd.fs.js";

export class Msg extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Fetched", "FetchFailed", "Handled"];
    }
}

export function Msg$reflection() {
    return union_type("TagungsProgramm.Api.Msg", [], Msg, () => [[["Item", Result$reflection()]], [["Item", class_type("System.Exception")]], [["Item", Command$reflection()]]]);
}

export const moduleId = (() => {
    const container = document.getElementById(fableModule.Platzhalter);
    return container.dataset["moduleid"];
})();

export const moduleName = fableModule.ModuleName;

function query$0027(query_1) {
    return Fetch_post_3817AB3A(moduleId, moduleName, "service/query", query_1, void 0, void 0, void 0, {
        ResolveType: Result$reflection,
    }, {
        ResolveType: Query$reflection,
    });
}

function handle$0027(command) {
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Fetch_post_3817AB3A(moduleId, moduleName, "service/handle", command, void 0, void 0, void 0, {
        ResolveType: () => unit_type,
    }, {
        ResolveType: Command$reflection,
    }).then((() => (Promise.resolve(command)))))));
}

export function query(q) {
    return Cmd_OfPromise_either((query_1) => query$0027(query_1), q, (arg0) => (new Msg(0, arg0)), (arg0_1) => (new Msg(1, arg0_1)));
}

export function handle(c) {
    return Cmd_OfPromise_either((command) => handle$0027(command), c, (arg0) => (new Msg(2, arg0)), (arg0_1) => (new Msg(1, arg0_1)));
}

